(function () {
  'use strict';

  /* @ngdoc object
   * @name vcclient
   * @description
   *
   */
  angular
    .module('vcclient', [
      'restmod',
      'ui.router',
      'ui.bootstrap',
      'as.sortable',
      'vcreminder',
      'vcutils.sprhelp',
      'vcutils.zipcode',
      'vcutils.doctor',
      'vcutils.sv',
      'vcutils.rlog',
      'vcutils.vcfields'
    ]);
}());
